var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.406 11.742c-.036.04-.07.081-.1.125a.632.632 0 0 0-.075.15.533.533 0 0 0-.05.15 1.134 1.134 0 0 0 0 .167.7.7 0 0 0 .066.316.75.75 0 0 0 .45.45.783.783 0 0 0 .634 0 .75.75 0 0 0 .45-.45.833.833 0 0 0 .05-.316.834.834 0 0 0-1.425-.592ZM8.997.667a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667Zm0 15a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334Zm0-10.833a2.5 2.5 0 0 0-2.166 1.25.833.833 0 1 0 1.441.833.833.833 0 0 1 1.315-.173.833.833 0 0 1-.59 1.423.833.833 0 0 0-.833.833v.834a.833.833 0 1 0 1.667 0v-.15a2.5 2.5 0 0 0-.834-4.85Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b87f69b3fb1fb0abd89eb48b7a2f7ee3.svg";
export { ForwardRef as ReactComponent };